import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { salesforceV2ObjectMetadata } from './salesforce-v2-object-metadata';

export const salesforceServiceCloudV2ObjectMetadata: IDatasetTypeMetadata = {
    ...salesforceV2ObjectMetadata,
    type: adfModelTypeMap.salesforceServiceCloudV2.datasetType,
    datasetNamePrefix: adfModelTypeMap.salesforceServiceCloud.datasetType,
    displayName: __IS_FABRIC_DPE__ ? stringResources.SalesforceServiceCloudObject_DisplayText : stringResources.SalesforceServiceCloudV2Object_DisplayText,
    supportLinkedServiceTypes: [adfModelTypeMap.salesforceServiceCloudV2.linkedServiceType]
};
